import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import languageReducer from '@axa-asia/hk-shared-utils/lib/languageReducer';

export default combineReducers({
  routing: routerReducer,
  language: languageReducer
});



// WEBPACK FOOTER //
// ./src/app/reducers/reducers.js